import routes from "../../../../../core/services/common/api-routes"
import {HttpAuthGet, HttpAuthPost, HttpAuthDelete} from "../../../../../core/services/common/HttpRequestBuilder"

const roleAccess = (parameters) => {
    let result = HttpAuthGet(routes.GET_ACC, parameters);
    return result;
}

const addRoleAccess = (payload) => {

    let result = HttpAuthPost(routes.ADD_ACC, payload);
    return result;
}

const removetRoleAccess = (parameters) => {

    let result = HttpAuthDelete(routes.REMOVE_ACC, parameters);
    return result;
}


const AccessControlService = {
    roleAccess,
    addRoleAccess,
    removetRoleAccess
}

export default AccessControlService
